export default "__VITE_ASSET__D4UUYRqw__"